import { ContactForm } from "./components/ContactForm";

const ContactPage = () => {
  return (
    <section className="max-w-2xl mx-auto px-6 md:px-8 py-16 text-center">
      <h2 className="font-display text-2xl uppercase-track mb-8">Inquire</h2>
      <p className="font-display text-2xl my-4">
        <a
          href="mailto:kinsjones@proton.me"
          className="border-b border-[var(--color-kj-border)] hover:border-[var(--color-kj-text)] transition-colors"
        >
          kinsjones@proton.me
        </a>
      </p>
      <p className="text-xs uppercase-track text-[var(--color-kj-text-light)] mb-12">
        <a
          href="https://instagram.com/kins.jones.art"
          target="_blank"
          rel="noopener"
          className="hover:text-[var(--color-kj-text)] transition-colors"
        >
          @kins.jones.art
        </a>
      </p>

      <ContactForm />
    </section>
  );
};

export default ContactPage;
